module.exports = __webpack_public_path__ + "static/dagny-bolditalic-bc923b02da64160c7585213b6112e2b6.woff";